<template lang="pug">
    v-form.c-form(autocomplete="off" @submit.prevent="submit")
        // Email field
        v-text-field(
            name="email"
            :label="$t('fields.email')"
            type="email"
            v-model="model.email"
            v-validate="{ required: true, email: true }"
            :data-vv-as="$t('fields.email')"
            :error-messages="errors.collect('email')"
            :disabled="!!this.$route.query.email"
            :append-icon="this.$route.query.email ? 'lock' : null"
            browser-autocomplete="new-password"
            outline
        )

        // Password field
        v-text-field(
            name="password"
            :label="$t('fields.password')"
            v-model="model.password"
            v-validate="{ required: true, min: 6, max: 24, verify_password: true }"
            :data-vv-as="$t('fields.password')"
            :error-messages="errors.collect('password')"
            browser-autocomplete="new-password"
            outline

            ref="password"
            :append-icon="visibilityPassword ? 'visibility' : 'visibility_off'"
            @click:append="() => (visibilityPassword = !visibilityPassword)"
            :type="visibilityPassword ? 'text' : 'password'"
        )

        // Password Confirm field
        v-text-field(
            name="passwordConfirmation"
            v-model="model.passwordConfirmation"
            :label="$t('fields.confirm_password')"
            v-model.lazy="model.passwordConfirmation"
            v-validate="{ required: true, min: 6, max:24, is: model.password, verify_password: true }"
            :data-vv-as="$t('fields.confirm_password')"
            :error-messages="errors.collect('passwordConfirmation')"
            outline

            data-vv-as="Confirm Password"
            :append-icon="visibilityPasswordConfirmation ? 'visibility' : 'visibility_off'"
            @click:append="() => (visibilityPasswordConfirmation = !visibilityPasswordConfirmation)"
            :type="visibilityPasswordConfirmation ? 'text' : 'password'"
        )

        div
            // Submit button
            button-component.mx-0.full-width(
                large
                type="submit"
                color="primary"
                size="medium"
                :action="submit"
                :isLoading="isLoading"
            ) {{ $t('auth.firstLogin.button') }}

</template>

<script>
    import Button from '~components/Button';
    import { mapActions, mapGetters } from 'vuex';

    export default {
        $_veeValidate: {
            validator: 'new'
        },
        components: {
            ButtonComponent: Button
        },
        data() {
            return {
                model: {
                    email: this.$route.query.email,
                    password: null,
                    passwordConfirmation: null,
                    token: this.$route.query.token
                },
                visibilityPassword: false,
                visibilityPasswordConfirmation: false
            };
        },
        computed: {
            ...mapGetters('auth', ['isLoading'])
        },
        mounted() {
            const dict = {
                custom: {
                    email: {
                        email: 'Invalid Email',
                        required: 'Email field is required'
                    },
                    password: {
                        required: 'Password field is required',
                        min: 'Your Password must be at least 8 characters.',
                        max:
                            'Your Password may not be greater than 24 characters'
                    },
                    passwordConfirmation: {
                        required: 'Confirm Password field is required',
                        is: 'Oops! It looks like your Password doesn’t match.',
                        min: 'Your Password must be at least 8 characters.',
                        max:
                            'Your Password may not be greater than 24 characters'
                    }
                }
            };

            this.$validator.localize('en', dict);
        },
        methods: {
            ...mapActions('auth', ['confirmPassword']),

            /**
             * Change password and login user on submit
             */
            async submit() {
                const validation = await this.$validator.validateAll();
                if (!validation) return;

                this.confirmPassword(this.model);
            }
        }
    };
</script>
